import { c as _c } from "react/compiler-runtime";
// hooks/useGlobalDisclosure.ts
import { useCallback } from 'react';
import { useAtom } from 'jotai';
import { portfolioOpenAtom } from '@/config/atoms/portfolio/portfolioOpen';
export type PortfolioTab = 'portfolio' | 'txs' | 'nfts'; // Add other tab options as needed

export function usePortfolioOpen() {
  const $ = _c(12);
  const [state, setState] = useAtom(portfolioOpenAtom);
  let t0;
  if ($[0] !== setState) {
    t0 = tab => {
      setState(prev => ({
        ...prev,
        isOpen: true,
        selectedTab: tab || "portfolio"
      }));
    };
    $[0] = setState;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const onOpen = t0;
  let t1;
  if ($[2] !== setState) {
    t1 = open => {
      setState(prev_0 => ({
        ...prev_0,
        isOpen: open
      }));
    };
    $[2] = setState;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const onOpenChange = t1;
  let t2;
  if ($[4] !== setState) {
    t2 = tab_0 => {
      setState(prev_1 => ({
        ...prev_1,
        selectedTab: tab_0
      }));
    };
    $[4] = setState;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const setSelectedTab = t2;
  let t3;
  if ($[6] !== onOpen || $[7] !== onOpenChange || $[8] !== setSelectedTab || $[9] !== state.isOpen || $[10] !== state.selectedTab) {
    t3 = {
      isOpen: state.isOpen,
      selectedTab: state.selectedTab,
      onOpen,
      onOpenChange,
      setSelectedTab
    };
    $[6] = onOpen;
    $[7] = onOpenChange;
    $[8] = setSelectedTab;
    $[9] = state.isOpen;
    $[10] = state.selectedTab;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  return t3;
}